import { HeaderRoot, SetViewType, ViewTypeToggle } from '@common/components';
import { SelectTeamFabric } from '@common/Fabric/SelectTeamFabric';
import { EntityCrumb } from '@common/Header/EntityCrumb';
import { useIDEParams, useIdeState } from '@common/ide/state';
import { useSelector } from '@common/performance/useSelector';
import { Entity } from '@common/types/Entity';
import { Private_Routes } from '@common/url';
import { ViewType } from '@LSP/types';
import { ActivityIcon, ChevronLeftDoubleIcon, ChevronRightDoubleIcon, CheckIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Button, Stack } from '@prophecy/ui-v3';
import styled from 'styled-components';

import { useObservationIDE } from '../hooks';
import { ObservationState } from '../redux/types';
import { getObservabilityLabelName } from '../util';

const StyledSelect = styled(SelectTeamFabric)`
  width: 200px;
  z-index: 1;
`;

type HeaderProps = {
  viewType: ViewType;
  setViewType: SetViewType;
  showProjectBrowser: boolean;
  toggleProjectBrowser: (value: boolean) => void;
};

export function Header({ showProjectBrowser, setViewType, viewType, toggleProjectBrowser }: HeaderProps) {
  const projectName = useIdeState((state) => state.project.name);
  const fabricId = useSelector<ObservationState, string>((state) => state.observationMetadata.fabricId);
  const currentEntity = Entity.Observation;
  const observedEntity = useIDEParams().observedEntity || Entity.Project;
  const { changeFabric } = useObservationIDE();

  return (
    <HeaderRoot>
      <Stack direction='horizontal' alignY='center' gap={theme.spaces.x8}>
        {projectName && (
          <Button
            variant='secondaryGray'
            size='s'
            onClick={() => toggleProjectBrowser(!showProjectBrowser)}
            icon={
              showProjectBrowser ? <ChevronLeftDoubleIcon type='default' /> : <ChevronRightDoubleIcon type='default' />
            }
            aria-label={showProjectBrowser ? 'Hide project browser' : 'Show project browser'}
            data-test-id='observation-header-toggle-project-browser-button'
          />
        )}
        <EntityCrumb
          parentEntityName={getObservabilityLabelName()}
          parentEntityUrl={Private_Routes.IDE_Home.getUrl({ entity: currentEntity.toLowerCase() })}
          parentEntityIcon={<ActivityIcon type='default' size='xs' />}
          entityName={projectName}
          entityType={Entity.Project}
        />
      </Stack>
      {observedEntity === Entity.Project ? (
        <ViewTypeToggle
          disabled={true}
          entity={Entity.Observation}
          viewType={viewType}
          setViewType={setViewType}
          visualLabel={'Lineage'}
          codeLabel={'Timeline'}
        />
      ) : (
        <div></div>
      )}
      <StyledSelect
        size='s'
        showSearch={true}
        hasExpiredTag={false}
        onChange={changeFabric}
        placement='bottomRight'
        aria-label='Select Fabric'
        data-test-id='observation-header-fabric-select'
        icon={fabricId ? <CheckIcon type='default' color={theme.colors.success500} /> : null}
        value={fabricId}
      />
    </HeaderRoot>
  );
}
